<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Mes demandes</span>
        <h3 class="page-title">Demande de recuperation</h3>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col">
        <div
          class="card card-small mb-4 mt-3"
          v-if="loading || !user.connected"
        >
          <div class="card-body">
            <spinner-dot />
          </div>
        </div>
        <template v-else>
          <step-one-recovery
            v-if="step === 1"
            :user.sync="user"
            @input="step = 2"
          />
          <step-two-recovery-time
            v-if="step === 2 || step === 3"
            :user.sync="user"
            @input="handleStepTwo"
            :step="step"
            @saveRequest="handleStepThree"
          >
            <template slot="topText">
              <p v-if="step === 2">
                Veuillez renseigner les jours ou vous souhaitez récupérer:
              </p>
              <p v-else>
                Vérifiez vos informations puis confirmez la demande ou appuyez
                sur Retour pour les modifier:
              </p>
            </template>
          </step-two-recovery-time>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerDot from '../../components/layout/Loading/spinner-dot';
import StepOneRecoveryTime from '../../components/daysOffRequest/recoveryTimeRequest/StepOne';
import StepTwoRecoveryTime from '../../components/daysOffRequest/recoveryTimeRequest/StepTwo';
import StepOneRecovery from '../../components/daysOffRequest/recoveryRequest/StepOne';

export default {
  name: 'RecoveryRequest',
  components: {
    StepOneRecovery,
    StepTwoRecoveryTime,
    StepOneRecoveryTime,
    SpinnerDot,
  },
  data() {
    return {
      request: {},
      step: 1,
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.informations;
    },
  },
  methods: {
    handleStepTwo({ dates, comments }) {
      if (!dates) {
        this.step -= 1;
      } else {
        this.request.dates = dates;
        this.request.comments = comments;
        this.step = 3;
      }
    },

    handleStepThree(totalHours) {
      this.loading = true;
      const form = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        userReference: this.user.reference,
        type: 'RECOVERY_REQUEST',
        dates: this.request.dates,
        model: {
          comments: this.request.comments,
          totalHours,
        },
      };
      this.$services.absenceRequest.createOne(form).then(() => {
        this.$miniToastr.success(this.$t('days.off.request.success'));
        this.$router.push('/demandes/historique');
      });
    },
  },
};
</script>

<style scoped>
</style>
